/**
  * vee-validate v3.4.15
  * (c) 2023 Abdelrahman Awad
  * @license MIT
  */

var validate$j = function (value, _a) {
  var multiple = (_a === void 0 ? {} : _a).multiple;
  // eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (multiple && !Array.isArray(value)) {
    value = String(value).split(',').map(function (emailStr) {
      return emailStr.trim();
    });
  }
  if (Array.isArray(value)) {
    return value.every(function (val) {
      return re.test(String(val));
    });
  }
  return re.test(String(value));
};
var params$c = [{
  name: 'multiple',
  default: false
}];
var email = {
  validate: validate$j,
  params: params$c
};
function isNullOrUndefined(value) {
  return value === null || value === undefined;
}
function isEmptyArray(arr) {
  return Array.isArray(arr) && arr.length === 0;
}
var validate$a = function (value, _a) {
  var length = _a.length;
  if (isNullOrUndefined(value)) {
    return length >= 0;
  }
  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$a(val, {
        length: length
      });
    });
  }
  return String(value).length <= length;
};
var params$8 = [{
  name: 'length',
  cast: function (value) {
    return Number(value);
  }
}];
var max = {
  validate: validate$a,
  params: params$8
};
var validate$9 = function (value, _a) {
  var max = _a.max;
  if (isNullOrUndefined(value) || value === '') {
    return false;
  }
  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) {
      return validate$9(val, {
        max: max
      });
    });
  }
  return Number(value) <= max;
};
var params$7 = [{
  name: 'max',
  cast: function (value) {
    return Number(value);
  }
}];
var max_value = {
  validate: validate$9,
  params: params$7
};
var validate$7 = function (value, _a) {
  var length = _a.length;
  if (isNullOrUndefined(value)) {
    return false;
  }
  if (Array.isArray(value)) {
    return value.every(function (val) {
      return validate$7(val, {
        length: length
      });
    });
  }
  return String(value).length >= length;
};
var params$6 = [{
  name: 'length',
  cast: function (value) {
    return Number(value);
  }
}];
var min = {
  validate: validate$7,
  params: params$6
};
var validate$6 = function (value, _a) {
  var min = _a.min;
  if (isNullOrUndefined(value) || value === '') {
    return false;
  }
  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) {
      return validate$6(val, {
        min: min
      });
    });
  }
  return Number(value) >= min;
};
var params$5 = [{
  name: 'min',
  cast: function (value) {
    return Number(value);
  }
}];
var min_value = {
  validate: validate$6,
  params: params$5
};
var validate$3 = function (value, _a) {
  var allowFalse = (_a === void 0 ? {
    allowFalse: true
  } : _a).allowFalse;
  var result = {
    valid: false,
    required: true
  };
  if (isNullOrUndefined(value) || isEmptyArray(value)) {
    return result;
  }
  // incase a field considers `false` as an empty value like checkboxes.
  if (value === false && !allowFalse) {
    return result;
  }
  result.valid = !!String(value).trim().length;
  return result;
};
var computesRequired$1 = true;
var params$3 = [{
  name: 'allowFalse',
  default: true
}];
var required = {
  validate: validate$3,
  params: params$3,
  computesRequired: computesRequired$1
};
export { email, max, max_value, min, min_value, required };